/**
 * This is a view model for course specific data and functions.
 * All course specific functions should be moved here from training.js, and rename it page.js, because it is actually page VM.
 *
 */

define('course',[],function() {
    'use strict';

    return function(viewModel, dataContext) {
        var self                = this,
            data                = dataContext.learning,
            lang                = null,
            training            = null,
            components          = null,
            UITexts             = {};

        if (!data || !data.current) {
            return;
        }

        self.dataContext = dataContext;

        training    = data.training;
        lang        = data.lang;

        if(training.componentsJson){
            var comps = JSON.parse(training.componentsJson);

            components = convertComponents(comps);

            // updates UI texts with admin defaults
            var tmp = getComponentsByKind('UITexts');
            if(tmp.length > 0){
                UITexts = tmp[0];
                for(var item in UITexts.content){
                    if(item != "index" && typeof UITexts.content[item] === 'string') {
                        lang[item] = UITexts.content[item];
                    }
                }
            }

            // updates UI texts with admin customs (if found)
            tmp = getComponentsByKind('CustomUITexts');
            if(tmp.length > 0){
                UITexts = tmp[0];
                for(var item2 in UITexts.content){
                    if(item2 != "index" && UITexts.content[item2].length > 0) lang[item2] = UITexts.content[item2][0].content.text;
                }
            }
        }

        /* Public functions */

        self.getComponentsByKind = getComponentsByKind;  // a function


        /* Private functions */

        function getComponentsByKind(kind) {
            var comps = [];

            if(components != null){
                if(components.length > 0) {
                    components.forEach(function (component) {
                        if(component.kind == kind) {
                            comps.push(component);
                        }
                    });
                }
            }
            return comps;
        }

        function convertComponents(comps){
            // combine 'key' and 'value' params to variables with 'key's value as name and 'value's value as value :)
            if(comps) {
                if (comps.length > 0) {
                    comps.forEach(function (comp) {
                        if (comp.content.length > 0) {
                            var content = {index: []};
                            comp.content.forEach(function (item) {
                                //console.log(item.key +": "+ item.value);
                                content[item.key] = item.value;
                                content.index.push(item.key);
                                if (content[item.key] instanceof Array && content[item.key].length) {
                                    //console.dir(content[item.key]);
                                    if (content[item.key][0].content != undefined) {
                                        content[item.key] = convertComponents(item.value);
                                    }
                                }
                            });
                            comp.content = content;
                        }
                    });
                }
            }else{
                // empty array
                comps = [];
            }
            return comps;
        }
    };
});

